import { useEffect, useState } from "react";
import { AdminLimits, AdminProductOption, fetchAdminProducts } from "../../../services/platformApi";

const DEFAULT_ADMIN_LIMITS: AdminLimits = {
  bulkEmailInputCharLimit: 20000,
  bulkEmailLimit: 50,
  userCheckConcurrency: 5,
};

export const useAdminProducts = () => {
  const [availableProducts, setAvailableProducts] = useState<AdminProductOption[]>([]);
  const [adminLimits, setAdminLimits] = useState<AdminLimits>(DEFAULT_ADMIN_LIMITS);
  const [productsLoading, setProductsLoading] = useState(false);
  const [adminLoadError, setAdminLoadError] = useState("");

  useEffect(() => {
    const loadAdminProducts = async () => {
      setProductsLoading(true);
      setAdminLoadError("");

      try {
        const response = await fetchAdminProducts();
        setAvailableProducts(response.products);
        setAdminLimits(response.limits || DEFAULT_ADMIN_LIMITS);
      } catch (error) {
        setAdminLoadError(
          error instanceof Error ? error.message : "Nepavyko užkrauti produktų sąrašo"
        );
      } finally {
        setProductsLoading(false);
      }
    };

    loadAdminProducts();
  }, []);

  return {
    availableProducts,
    adminLimits,
    productsLoading,
    adminLoadError,
  };
};
